import {
	CursorDataItem,
	VectorImageData,
	Component,
	ResolvedRefArray,
	ResolvedVariantRelation,
} from '@wix/thunderbolt-becky-types'
import { createCompNode, NodeRefs } from '@wix/thunderbolt-catharsis'
import { isRefArray, isValidShape } from './shapeIdsNode'

type ResolvedCursorDataItem = CursorDataItem & { media: VectorImageData }
const isResolvedVariantRelation = <T>(item: T | ResolvedVariantRelation<T>): item is ResolvedVariantRelation<T> =>
	'to' in item && 'variants' in item

const getSvgId = (cursor: ResolvedCursorDataItem) => cursor.media?.svgId

export const cursorShapeIdsNode = createCompNode({
	getDependencies: (component: Component, refs: NodeRefs<{}>) => {
		return {
			cursorData: component.cursorQuery
				? refs.cursorQuery<ResolvedCursorDataItem>(component.cursorQuery)
				: undefined,
		}
	},
	toViewItem: (__, { cursorData }) => {
		if (!cursorData) {
			return []
		}

		if (isRefArray<ResolvedCursorDataItem>(cursorData)) {
			const shapeIds = (cursorData as ResolvedRefArray<ResolvedCursorDataItem>).values
				.map((cursor) => {
					const svgId = isResolvedVariantRelation(cursor) ? getSvgId(cursor.to) : getSvgId(cursor)
					return svgId
				})
				.filter(isValidShape)
			return shapeIds
		}

		const svgId = getSvgId(cursorData)
		return isValidShape(svgId) ? [svgId] : []
	},
})
